import { render } from "./ProfileAnalyticsChart.vue?vue&type=template&id=2dd191d8"
import script from "./ProfileAnalyticsChart.vue?vue&type=script&lang=js"
export * from "./ProfileAnalyticsChart.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__